/*
    Utility functions for providing image path strings
    - Uses https://picsum.photos/ for placeholder images
    - Uses https://www.contentful.com/developers/docs/references/images-api/#/reference for production images
*/

/*
    * Create SrcSet string for HTML5 <img srcSet="" />
    * @param {String} url - URL of CDN
    * @param {Array} sizes - Array of objects that contain `width`, `height` and `quality` integers
    * @param {Bool} placeholder - Defines which syntax format/template we use for appending to the image information to the CDN url
    * @returns {String} Urls for HTML5 Image `srcSet` attribute
*/
export function imageSrcSet(url, sizes, placeholder) {
    let srcString = ``;

    sizes.forEach(size => {
        const quality = size.quality ? size.quality : 70;

        if (placeholder) {
            srcString += `${url}/${size.width}/${size.height}?image=502 ${
                size.width
            }w, `;
        } else {
            srcString += `${url}?fm=jpg&w=${size.width}&h=${
                size.height
            }&fit=thumb&q=${quality} ${size.width}w, `;
        }
    });

    return srcString;
}

/*
    * Create image url string for <img src="" /> using the first item specified in the passed array of sizes
    * @param {String} url - URL of CDN
    * @param {Object} size - Object containing `width`, `height` and `quality` integers
    * @param {Bool} placeholder - Defines which syntax format/template we use for appending to the image information to the CDN url
    * @returns {String} Url for HTML Image `src` attribute
*/
export function imageSrc(url, size, placeholder) {
    let srcString = ``;
    const quality = size.quality ? size.quality : 70;

    if (placeholder) {
        srcString += `${url}/${size.width}/${size.height}?image=502`;
    } else {
        srcString += `${url}?fm=jpg&w=${size.width}&h=${
            size.height
        }&fit=thumb&q=${quality}`;
    }

    return srcString;
}



// WEBPACK FOOTER //
// ./src/utils/images.js